module.exports = __webpack_public_path__ + "img/2024_team.c57619be.webp";